import { render, staticRenderFns } from "./ModalCriarConta.vue?vue&type=template&id=69418ff0&"
import script from "./ModalCriarConta.vue?vue&type=script&lang=js&"
export * from "./ModalCriarConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports